<template>
	<div>
		<!-- 企业咨询 -->
		<el-row class="right-box-row" style="min-height: 430px;">
			<el-row class="right-box-row-title">
				<el-col :span="20">
					{{tableTitle}}
				</el-col>
				<el-col :span="4" style="color: #333333;font-size: 14px;font-weight:100;">
					点击量:{{pv.clickNum}}次
				</el-col>
			</el-row>
			<!-- 医疗器械产品注册资料预审 -->
			<div style="margin: 20px 0;"></div>
			<el-descriptions>
				<el-descriptions-item label="企业名称">{{ylqxForm.entname}}</el-descriptions-item>
				<el-descriptions-item label="统一社会信用代码">{{ylqxForm.uniscid}}</el-descriptions-item>
			</el-descriptions>
			<!--<el-alert
                  title="请正确填写上传所需材料"
                  show-icon
                  type="warning">
          </el-alert>-->
			<el-form ref="ylqxform" :model="ylqxForm" label-width="80px" style="margin-top: 20px;" :rules="ylqxrules">
				<el-row>
					<el-col :span="24" align="left">
						<el-form-item label="问题描述:" prop="regContent" label-width="85px">
							<el-input type="textarea"
								placeholder="请输入问题描述内容（产品注册申报过程中的问题，法律法规实施相关问题等，描述具体问题情况，需要进行资料预审的可以附件形式上传）"
								v-model="ylqxForm.regContent" maxlength="150" :autosize="{ minRows: 6, maxRows: 8}"
								show-word-limit>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<div style="margin: 20px 0;"></div>
				<el-row>
					<el-col :span="24">
						<span style="float: left;">
							<attachment-list-size :size="300" :listType="listType" module="zlts_ylqxcx_qyzx"
								:businessid="ylqxForm.recid" :limit="ylqxLimit" :accept="accept" @isEmitFun="isEmitFun">
							</attachment-list-size>
						</span>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item>
							<el-checkbox v-model="ylqxForm.iscn">
								我承诺：我所填写的申请信息真实有效。我单位对填写的内容真实性负责，如有虚假将依法承担相应责任
							</el-checkbox>
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item>
					<el-button type="primary" :disabled="!ylqxForm.iscn" @click="toSubmit('ylqx')">提交</el-button>
				</el-form-item>
			</el-form>

		</el-row>
	</div>
</template>

<script>
	import {
		addYlqx
	} from "@/api/zlts/ylqxcx/qyzx";
	import AttachmentListSize from "../../../../components/AttachmentListSize";
	import {
		updatePvNum,
		getPv
	} from "@/api/itempv/pv";
	export default {
		name: "Ylqxcx-qyzx",
		components: {
			AttachmentListSize,
		},
		props: {
			tableTitle: {
				type: String,
				required: true
			},
		},
		data() {
			return {
				//医疗器械form
				ylqxForm: {
					recid: undefined,
					entname: undefined,
					uniscid: undefined,
					iscn: false,
					type: 'ylqxcx',
					ywFwjgRecid: undefined,
					regContent: undefined,
				},
				ylqxrules: {
					regContent: [{
						type: 'string',
						required: true,
						message: "请输入问题描述内容",
						trigger: 'blur'
					}, {
						max: 150,
						message: "长度不能超过150"
					}]
				},
				//医疗器械上传附件限制一个附件
				ylqxLimit: 1,
				//组件是否上传
				isUpload: false,
				listType: 'text',
				accept: ".doc, .docx, .xls, .xlsx, .pdf, .jpg, .png",
				isLoginState: undefined,
				pv:{
					clickNum:undefined,
				},

			}
		},
		created() {
			this.loginUser = JSON.parse(localStorage.getItem("sdtyfwpt_loginuser"));
			// console.log(this.loginUser)
			if (this.loginUser != null && this.loginUser != undefined) {
				this.ylqxForm.uniscid = this.loginUser.cornumber;
				this.ylqxForm.entname = this.loginUser.corname;
				this.ylqxForm.ywFwjgRecid = this.loginUser.ywFwjgRecid;
			}
			updatePvNum("zlts_ylqxcx_qyzx").then(response => {
				//pv 点击企业咨询
			});
			this.getPvJbxx();
			this.resetData();
		},
		methods: {
			getPvJbxx(){
				// 获取pv点击量
				getPv("zlts_ylqxcx_qyzx").then(response => {
					this.pv = response;
				});
			},
			resetData() {
				this.ylqxForm.recid = this.randomString();
				this.ylqxForm.iscn = false;
				this.ylqxForm.regContent = undefined;

			},
			toSubmit() {
				if (this.utils.isLoginTimeout()) {
					let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
					if (ssessionLoginUser != null && ssessionLoginUser != undefined) {
						let ywFwjg = ssessionLoginUser.ywFwjg;
						if (ywFwjg == null) {
							this.msgWarning('参数有误！');
							this.resetData();
							return false;
						}
						if (ssessionLoginUser.user.ywFwjgRecid === null || ssessionLoginUser.user.ywFwjgRecid === "" ||
							ssessionLoginUser.user.ywFwjgRecid === undefined) {
							this.msgWarning('参数有误！');
							this.resetData();
							return false;
						}
						if (ywFwjg.userType === '1') {
							this.msgWarning('您不是企业用户，不能操作此业务！');
							this.resetData();
							return false;
						}
						if (ywFwjg.userType === '2' && ywFwjg.entcat === '2') {
							this.msgWarning('您不是企业用户，不能操作此业务！');
							this.resetData();
							return false;
						} else {
							this.ylqxForm.ywFwjgRecid = ssessionLoginUser.user.ywFwjgRecid;
							//医疗器械
							this.ylqxSubmit();

						}
					}
				} else {
					this.$confirm('您未登录或登录已过期，您可以继续留在该页面，或者重新登录?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.logout(this.ywFwjgRecid)
					})
				}
			},
			/** 医疗器械提交按钮 */
			ylqxSubmit() {
				this.$refs["ylqxform"].validate(valid => {
					if (valid) {
						// if (this.isUpload) {
						if (this.ylqxForm.iscn) {
							this.$confirm('是否提交？', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								addYlqx(this.ylqxForm).then(response => {
									if (response.code === 200) {
										this.msgSuccess("提交成功");
										//this.$router.back();
										this.resetData();
										sessionStorage.removeItem("indexToRzfwCode");
										// sessionStorage.removeItem("indexToRzfwRegContent");
										sessionStorage.removeItem("indexToRzfwRecid");
									} else {
										this.msgError(response.msg);
									}
								});
							})
						} else {
							this.msgError("请选择承诺");
						}
						// } else {
						//     this.msgError("请上传附件");
						// }
					}
				})
			},
			isEmitFun(str) {
				if (str > 0) {
					this.isUpload = true;
				} else {
					this.isUpload = false;
				}
			},
		}
	}
</script>

<style scoped>
	.right-box-row {
		border: 1px solid #cccccc;
		padding: 0px 15px 0;
	}

	.right-box-row-title {
		padding: 15px 0;
		text-align: left;
		color: #409eff;
		font-size: 18px;
		font-weight: bold;
		border-bottom: 1px solid #cccccc;
		margin: 0px 0;
	}

	.right-box-row-title-1 {
		/* padding: 15px 0; */
		text-align: left;
		/* color: #409eff; */
		font-size: 18px;
		font-weight: bold;
		/* border-bottom: 1px solid #cccccc; */
		margin: 0;
	}

	/deep/ .el-input input {
		width: 25rem;
	}

	/deep/ .el-form-item {
		margin-bottom: 0;
	}

	.right-box-row-title-1 /deep/ .el-link--inner {
		margin-right: 20px;
	}
</style>
